import Vue from 'vue'

import sha1 from 'sha1'
window.sha1 = sha1;

import $ from 'jquery';
$.extend({
	formatFloat: function(src, pos) {
		var num = parseFloat(src).toFixed(pos);
		num = num.toString().replace(/\$|\,/g, '');
		if(isNaN(num)) num = "0";
		var sign = (num == (num = Math.abs(num)));
		num = Math.floor(num * 100 + 0.50000000001);
		var cents = num % 100;
		num = Math.floor(num / 100).toString();
		if(cents < 10) cents = "0" + cents;
		for(var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
			num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
		return(((sign) ? '' : '-') + num + '.' + cents);
	}
});

window.$ = $

import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)

Vue.prototype.$echarts = echarts

import axios from 'axios'
// axios.defaults.headers = {
//     "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
//     'Authorization':'Bearer' + JSON.parse(localStorage.json_user_info).token
// }
Vue.prototype.$http = axios
Vue.prototype.LS = {
	//存储基础型数据
	set(key, value) {
		if(this.get(key) !== null)
			this.remove(key);
		localStorage.setItem(key, value);
	},
	//存储对象，数组型数据
	setJSON(key, value) {
		if(this.getJSON(key) !== null)
			this.removeJSON(key);
		localStorage.setItem("json_" + key, JSON.stringify(value));
	},
	//获取基础数据
	get(key) {
		var v = localStorage.getItem(key);
		return v === undefined ? null : v;
	},
	//获取对象，数组型数据
	getJSON(key) {
		var v = localStorage.getItem("json_" + key);
		return v === undefined ? null : $.parseJSON(v);
	},
	//移除基础型数据
	remove(key) {
		localStorage.removeItem(key);
	},
	//移除对象，数组型数据
	removeJSON(key) {
		localStorage.removeItem("json_" + key);
	},
	//清理所有数据
	clear() {
		localStorage.clear();
	},
	//循环所有数据
	each(fn) {
		var n = localStorage.length,
			i = 0,
			fn = fn || function() {},
			key;
		for(; i < n; i++) {
			key = localStorage.key(i);
			if(fn.call(this, key, this.get(key)) === false)
				break;
			if(localStorage.length < n) {
				n--;
				i--;
			}
		}
	}
}

Vue.prototype.tokenFun = function(obj, ismode = false) {
	obj['callId'] = this.$root.callId;
	obj['reqTime'] = (new Date()).getTime().toString();
	if(ismode != false) {
		obj.mode = this.$root.logmode;
	}
	let resKey = [];
	$.each(obj, function(idx, val) {
		resKey.push(idx);
	});
	resKey.sort();
	let res = [];
	$.each(resKey, function(idx, val) {
		res.push(val + "=" + obj[val]);
	});
	res.push("callSecret" + "=" + this.$root.callSecret)
	obj['G-SignValue'] = sha1(res.join('&'));
	return obj;
}

Vue.prototype.delHtmlTag = function(str) {
	str = str.replace(/<style[^>]*?>[\s\S]*?<\/style>/g, "");
	str = str.replace(/<script[^>]*?>[\s\S]*?<\/script>/g, "");
	str = str.replace(/<[^>]+>/g, ""); //去掉所有的html标记
	str = str.replace(/(^\s+)|(\s+$)/g, ""); //去掉前后空格
	return str.replace(/\s/g, ""); //去除文章中间空格
}

Vue.prototype.tabDiv = function(str) {
	str = str == null ? "" : str;
	str = str.replace(/\r\n/g, "<br>")
	str = str.replace(/\r/g, "<br>"); 
	str = str.replace(/\n/g, "<br>"); 
	str = str.replace(/\s/g, "&nbsp;");
	return str;
}

Vue.prototype.GetLength = function(str) {
	return str.replace(/[^\x00-\xff]/g, "aa").length;
};

Vue.prototype.cookie = {
	getCookie(c_name) {
		if(document.cookie.length > 0) {
			c_start = document.cookie.indexOf(c_name + "=")
			if(c_start != -1) {
				c_start = c_start + c_name.length + 1
				c_end = document.cookie.indexOf(";", c_start)
				if(c_end == -1) c_end = document.cookie.length
				return unescape(document.cookie.substring(c_start, c_end))
			}
		}
		return null
	},
	setCookie(c_name, value, expiredays, domain) {
		var exdate = new Date()
		exdate.setDate(exdate.getDate() + expiredays)
		document.cookie = c_name + "=" + escape(value) +
			((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) +
			((domain == null) ? ";domain=.qiaonyu.com" : ";domain=" + domain)
	},
	checkCookie(c_name) {
		c_value = getCookie(c_name)
		if(c_value != null && c_value != "") {
			return true;
		} else {
			return false;
		}
	}
}
Vue.prototype.mobilereg = /^[1][3,4,5,7,8][0-9]{9}$/;
Vue.prototype.passwordreg = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
Vue.prototype.dynamicreg = /^[0-9a-zA-Z]{6}$/;
Date.prototype.format = function(format) {
	var o = {
		"M+": this.getMonth() + 1, //month
		"d+": this.getDate(), //day
		"h+": this.getHours(), //hour
		"m+": this.getMinutes(), //minute
		"s+": this.getSeconds(), //second
		"q+": Math.floor((this.getMonth() + 3) / 3), //quarter
		"S": this.getMilliseconds() //millisecond
	};
	if(/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}

	for(var k in o) {
		if(new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}
	}
	return format;
};


// WEBPACK FOOTER //
// ./src/api/base.js